import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { me } from 'lib/core/data/customer/me'
import { useCoreContext } from '../useCoreContext'

interface Params {
  customerAddressId: number
  onSuccess?: () => void
  onError?: () => void
}

export const useDeleteCustomerAddress = ({ customerAddressId, onError, onSuccess }: Params) => {
  const { magentoClient, onError: handleError } = useCoreContext()
  const dispatch = useDispatch()
  const [isFetching, setIsFetching] = useState(false)

  const deleteCustomerAddress = () => {
    setIsFetching(true)
    magentoClient?.customer.deleteCustomerAddress({ id: customerAddressId })
      .then(async () => {
        await dispatch(me())
        onSuccess?.()
        setIsFetching(false)
      }).catch(e => {
        onError?.()
        handleError?.(e)
        setIsFetching(false)
      })
  }

  return {
    isLoading: isFetching,
    deleteCustomerAddress
  }
}
